import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-sm-6" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "col-sm-1" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-times" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "col-sm-3" }
const _hoisted_9 = ["onUpdate:modelValue"]
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-sm-4" }
const _hoisted_12 = ["onUpdate:modelValue"]
const _hoisted_13 = { class: "col-sm-4" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "col-sm-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_tiny_editor = _resolveComponent("tiny-editor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Orari di apertura ticket",
          text: "Orari di apertura ticket"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-success",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addTime && _ctx.addTime(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Aggiungi orario",
            text: "Aggiungi orario"
          })
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localValue.times, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row",
          key: i
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: ($event: any) => (_ctx.removeTime(i))
            }, _hoisted_7, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Giorno",
                text: "Giorno"
              })
            ]),
            _withDirectives(_createElementVNode("select", {
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((item.day) = $event)
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, i) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: i,
                  value: i
                }, _toDisplayString(day), 9, _hoisted_10))
              }), 128))
            ], 8, _hoisted_9), [
              [_vModelSelect, item.day]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Orario di <b>INIZIO</b> per apertura ticket <small>(se non va in automatico, usare il formato HH:mm)</small>",
                text: "Orario di <b>INIZIO</b> per apertura ticket <small>(se non va in automatico, usare il formato HH:mm)</small>"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "time",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((item.startTime) = $event)
            }, null, 8, _hoisted_12), [
              [_vModelText, item.startTime]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("label", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Orario di <b>FINE</b> per apertura ticket <small>(se non va in automatico, usare il formato HH:mm)</small></label>",
                text: "Orario di <b>FINE</b> per apertura ticket <small>(se non va in automatico, usare il formato HH:mm)</small></label>"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "time",
              class: "form-control",
              "onUpdate:modelValue": ($event: any) => ((item.endTime) = $event)
            }, null, 8, _hoisted_14), [
              [_vModelText, item.endTime]
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("h5", null, [
        _createVNode(_component_localized_text, {
          localizedKey: "Messaggio degli orari",
          text: "Messaggio degli orari"
        })
      ]),
      _createVNode(_component_tiny_editor, {
        modelValue: _ctx.localValue.text,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localValue.text) = $event))
      }, null, 8, ["modelValue"])
    ])
  ]))
}